













































































































































































































































































import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import DataSourceList from '@/modules/HuntingLicenses/LicenseOrder/DataSourceList.vue';
import HuntingTicket from '@/modules/HuntingLicenses/LicenseOrder/HuntingTicket.vue';
import PersonalDataComponent from '@/modules/HuntingLicenses/LicenseOrder/PersonalDataComponent.vue';
import HuntingLicenseComponent from '@/modules/HuntingLicenses/LicenseOrder/HuntingLicenseComponent.vue';
import SeasonComponent from '@/modules/HuntingLicenses/LicenseOrder/SeasonComponent.vue';
import { GetResultsType, Goal, statusApplication } from '@/common/constants';
import BirdsFurryComponent from '@/modules/HuntingLicenses/LicenseOrderReport/BirdsFurryComponent.vue';
import UngulatesComponent from '@/modules/HuntingLicenses/LicenseOrderReport/UngulatesComponent.vue';
import HuntingPlace from '@/modules/HuntingLicenses/LicenseOrder/HuntingPlace.vue';
import { saveFileFromResponse } from '@/common/helpers';
import UseBackend from '@/core/mixins/use-backend';
import { CATALOGS_SEASONS, FILE_GET, HUNTING_LICENSE_ORDERS } from '@/common/api';

// eslint-disable-next-line no-use-before-define
@Component<HuntingLicenseOrderForm>({
  components: {
    HuntingPlace,
    BirdsFurryComponent,
    UngulatesComponent,
    SeasonComponent,
    HuntingLicenseComponent,
    PersonalDataComponent,
    HuntingTicket,
    DataSourceList,
  },
  data() {
    return { GOALS: Goal };
  },
})
export default class HuntingLicenseOrderForm extends mixins(UseBackend) {
  @Prop({
    required: true,
    type: Object,
  })
  value!: Orders.HuntingLicenseOrderReport;

  @Prop({
    required: true,
    type: Array,
  })
  seasons!: Array<unknown>;

  @Prop({
    required: true,
    type: Array,
  })
  zones!: Array<unknown>;

  @Prop({ default: Goal.permission })
  goal!: Goal;


  readonly: boolean = true;

  GetResultsType = GetResultsType;

  Status = statusApplication;

  private loading: boolean = false;

  get rejectStatus() {
    const { length } = this.value.statusHistory;
    if (length > 0) {
      return this.value.statusHistory[length - 1];
    }
    return null;
  }

  get ungulates(): Array<Orders.UngulatesBearsReport> {
    if (this.value.reportUngulatesBears && this.value.reportUngulatesBears.length > 0) {
      return this.value.reportUngulatesBears;
    }
    return [];
  }

  get birds(): Array<Orders.BirdsFurryReport> {
    if (this.value.reportBirdsFurry && this.value.reportBirdsFurry.length > 0) {
      return this.value.reportBirdsFurry;
    }
    return [];
  }

  get applicationUser(): string {
    if (this.value.user) {
      return `${this.value.user.lastName} ${this.value.user.firstName} ${this.value.user.middleName}`;
    }

    return 'Никто еще не принял в работу данное заявление';
  }

  async downloadFile(id: string) {
    const response = await this.makeRequest(() => this.$http({ ...FILE_GET(id), responseType: 'blob' }));
    saveFileFromResponse(response);
  }

  seasonLabel(value) {
    return `${value.name} ${value.seasonYear} года`;
  }

  timer: null | number = null;

  private timeout: number = 2000;

  startLoading() {
    this.loading = true;
  }

  finishLoading() {
    this.loading = false;
  }

  autosave() {
    this.resetTimout();
    this.timer = setTimeout(this.save, this.timeout);
  }

  private resetTimout() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  private save() {
    const data = {
      inn: this.value.recipientPersonalData.inn,
      isSemolinaDuck: this.value.isSemolinaDuck,
      zoneId: this.value.zoneId,
      seasonId: this.value.seasonId,
    };
    this.makeRequest(() => this.$http({ ...HUNTING_LICENSE_ORDERS.UPDATE(this.value.id), data }));
  }

  private async saveDataSources(dataSources: Record<number, number>, done: () => void) {
    const data = {
      dataSources,
    };
    const { data: value } = await this.makeRequest(() =>
      this.$http({ ...HUNTING_LICENSE_ORDERS.UPDATE(this.value.id), data }),
    );
    this.value.dataSources = value.dataSources;
    done();
  }
}
